import React from "react";

// #region -------------- Component -------------------------------------------------------------------

export class Footer extends React.PureComponent {
  public render() {
    const year = new Date().getFullYear();

    return (
      <footer className="rb-footer">
        <div className="container rb-footer-content">
          <div className="rb-footer-aside">
            {/* <a href="https://sourceforge.net/software/product/Peekdata/">
              <img width={50} height={50} src={sfLogo} alt="sf-logo" />
            </a> */}
          </div>
          <div>© {year}, Peekdata.io</div>
          {/* <div>
            Contact us: <a href="mailto:info@peekdata.io">info@peekdata.io</a>
          </div> */}
        </div>
      </footer>
    );
  }
}

// #endregion
